// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/fulfillment/delivery_method/v1/life_in_store_arranged_delivery.proto (package stailer_service_specification.fulfillment.delivery_method.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");

/**
 * Describes the file stailer_service_specification/fulfillment/delivery_method/v1/life_in_store_arranged_delivery.proto.
 */
const file_stailer_service_specification_fulfillment_delivery_method_v1_life_in_store_arranged_delivery = /*@__PURE__*/
  fileDesc("CmJzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9mdWxmaWxsbWVudC9kZWxpdmVyeV9tZXRob2QvdjEvbGlmZV9pbl9zdG9yZV9hcnJhbmdlZF9kZWxpdmVyeS5wcm90bxI8c3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uZnVsZmlsbG1lbnQuZGVsaXZlcnlfbWV0aG9kLnYxIh0KG0xpZmVJblN0b3JlQXJyYW5nZWREZWxpdmVyeWIGcHJvdG8z");

/**
 * Describes the message stailer_service_specification.fulfillment.delivery_method.v1.LifeInStoreArrangedDelivery.
 * Use `create(LifeInStoreArrangedDeliverySchema)` to create a new message.
 */
const LifeInStoreArrangedDeliverySchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_fulfillment_delivery_method_v1_life_in_store_arranged_delivery, 0);


exports.file_stailer_service_specification_fulfillment_delivery_method_v1_life_in_store_arranged_delivery = file_stailer_service_specification_fulfillment_delivery_method_v1_life_in_store_arranged_delivery;
exports.LifeInStoreArrangedDeliverySchema = LifeInStoreArrangedDeliverySchema;
